import DynamicReport from "./dynamic-report";
export default DynamicReport;
